<template lang="pug">
  .socials__links
    .socials__links-item(
      v-for="item in socials"
      :key="item.code"
      :class="`socials__links-item_${item.code}`"
    )
      .socials__links-item-icon(
        v-lazyload
        :class="`socials__links-item-icon_${item.code}`"
      )
      .socials__links-item-content
        .socials__links-item_text {{ item.title }}
        a.socials__links-item_btn(
          @click="sendMetricks"
          ref="items"
          :href="item.href"
        )
          span {{ item.text }}
</template>

<script>
import anime from 'animejs'
import { mapGetters } from 'vuex'
import inViewport from '@/helpers/inViewport'
import metricks from '@/mixins/metricks'

export default {
  name: 'SocialsLinks',
  mixins: [metricks],
  computed: {
    ...mapGetters('main', {
      socials: 'getSocialLinks'
    })
  },
  mounted () {
    this.$nextTick(() => {
      inViewport(this.$el, () => {
        anime({
          targets: this.$refs.items,
          opacity: [0, 1],
          duration: 400,
          delay: anime.stagger(200),
          easing: 'linear'
        })
      }, 'half')
    })
  }
}
</script>
